import CategoryIcon from "../../components/CategoryIcon";
import { parseDateToUSFormat } from "../../helpers/DateHelper";

export const parseNba = (data, getDocumentFunctions) => {
    const parsedOrders = [];

    parseNBACategories(data, parsedOrders);
        parseNBADocuments(data, parsedOrders, getDocumentFunctions);

    const lastDate = parseInspectionDateToString(data?.date)
    const prevDates = data.previousInspections?.map(item => parseInspectionDateToString(item.date))

    return {
        status: parsedOrders.map((o, index)=> {return {...o, id: index}}),
        date: lastDate,
        invoiceNumber: data.invoiceNumber,
        quoteNumber: data.quoteNumber,
        workOrderId: data.workOrderId,
        storeId: data.storeId,
        previousDates: prevDates,
        id: data.id,
    };
};

const parseNBACategories = (nextBestAction, parseList) => {
    parseList.push(
        createNBAObject(
            nextBestAction,
            { categoryIcon: "tires", categoryName: "NON-WINTER TIRES", categoryProperty: "Non-Winter Tires" }
        )
    );
    parseList.push(
        createNBAObject(
            nextBestAction,
            { categoryIcon: "tires", categoryName: "WINTER TIRES", categoryProperty: "Winter Tires" }
        )
    );
    parseList.push(
        createNBAObject(
            nextBestAction,
            { categoryIcon: "alignment", categoryName: "ALIGNMENT", categoryProperty: "Alignment" }
        )
    );
    parseList.push(
        createNBAObject(
            nextBestAction,
            { categoryIcon: "suspension", categoryName: "STEERING & SUSPENSION", categoryProperty: "Steering and Suspension Components" }
        )
    );
    parseList.push(
        createNBAObject(
            nextBestAction,
            { categoryIcon: "brakes", categoryName: "BRAKES", categoryProperty: "Brakes" }
        )
    );
    parseList.push(
        createNBAObject(
            nextBestAction,
            { categoryIcon: "Battery", categoryName: "BATTERY", categoryProperty: "Battery" }
        )
    );
}

const parseNBADocuments = (nextBestAction, parseList, getDocumentFunctions) => {
    parseList.push(
        createNBAObject(
            nextBestAction,
            { categoryIcon: "visit report", categoryName: "SSC REPORT" },
            getDocumentFunctions
        )
    );
    parseList.push(
        createNBAObject(
            nextBestAction,
            { categoryIcon: "visit documents", categoryName: "DOCUMENTS" },
            getDocumentFunctions
        )
    );
}

const validateComments = (nextBestAction, category, categoryName) => {
    return !nextBestAction.workOrderId && !nextBestAction.storeId ? "" : category.comments ? category.comments : categoryName === "DOCUMENTS" || categoryName === "SSC REPORT" ? "" : "No data available"
}

const createNBAObject = (nextBestAction, categoryProps, getDocumentFunctions = {}) => {
    const { categoryIcon, categoryName, categoryProperty } = categoryProps;
    const parsedCategoryIcon = convertCategoryToIcon(categoryName, categoryIcon);
    const category = categoryProperty ? nextBestAction[categoryProperty] || {} : nextBestAction;
    const result = {
        category: parsedCategoryIcon,
        lastVisit: processCategory(nextBestAction, category, categoryName, getDocumentFunctions),
        comments: validateComments(nextBestAction, category, categoryName)
    };

    const { previousInspections } = nextBestAction;
    if (previousInspections) {
        let i = 1
        previousInspections.forEach((item) => {
            const categoryItem = categoryProperty ? item[categoryProperty] : item
            const propertyName = `previousVisit${i++}`;
            result[propertyName] = processCategory(item, categoryItem, categoryName, getDocumentFunctions);
        })
    }
    return result;
};

const convertCategoryToIcon = (categoryName, categoryIcon) => {
    let rowDescription = processRowDescription(categoryName);
    return (
        <div style={{
                display: "flex", 
                alignItems: "center",
                gap: "4%",
                textAlign: "left"
            }}
        >
            <CategoryIcon category={categoryIcon} sx={{ width: 40, height: 40 }}/>
            {rowDescription}
        </div>
    );
};

const processRowDescription = (categoryName) => {
    switch (categoryName) {
        case "SSC REPORT":
        case "DOCUMENTS":
            return <label style={{ margin: "0" }}>{categoryName}<br />(CLICK TO VIEW)</label>
        default:
            return <label style={{ margin: "0" }}>{categoryName}</label>
    }
}

const convertValueToIcon = (status) => {
    return (
        <div style={{
            width: 40,
            height: 40,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden'
        }}>
            <CategoryIcon category={status} />
        </div>
    );
};

const processCategory = (inspection, categoryValue, categoryName, getDocumentFunctions) => {
    const {
        invoiceNumber,
        quoteNumber,
        storeId,
        workOrderId,
        invoiceSource,
        quoteSource,
        workOrderSource,
    } = inspection;
    const { value } = categoryValue;
    const { getPdfData, getPdfReport } = getDocumentFunctions;

    switch (categoryName) {
        case "DOCUMENTS":
            const invoiceLink = renderPdfLink("sh invoice", invoiceNumber, getPdfData, invoiceSource);
            const quoteLink = renderPdfLink("sh quote", quoteNumber, getPdfData, quoteSource);
            return invoiceLink || quoteLink ? <div className='shLink'> {quoteLink}{invoiceLink} </div> : null
        case "SSC REPORT":
            return workOrderId && storeId ? <a onClick={() => getPdfReport(storeId, workOrderId, workOrderSource)}>{convertValueToIcon("report")} </a> : null;
        default:
            return renderVisit(value, workOrderId, storeId);
    }
}

const renderVisit = (visit, workOrderId, storeId) => {
    return visit && visit != 'NA' ? convertValueToIcon(visit) : !workOrderId && !storeId ? "" : "No data available";
}

const renderPdfLink = (label, orderNumber, getPdfData, source) => {
    let documentType = label.slice(3);
    return orderNumber ? <a onClick={() => getPdfData(orderNumber, documentType, source)}>{convertValueToIcon(label)}</a> : null;
};

const parseInspectionDateToString = (date) => {
    const timezone = 'America/Los_Angeles'
    if (date != null) {
        return parseDateToUSFormat(date, timezone)
    }
    else {
        return "NO RECORDS FOUND";
    }
}